import {
  QuestionGradingType,
  QuestionType,
} from "services/KnowfullyAdminClient";
import { QuestionTypeEnum } from "types/common-types";

const multipleChoiceOrAnswersQuestionTypes = [
  QuestionTypeEnum.MultipleChoice.toString(),
  QuestionTypeEnum.MultipleAnswers.toString(),
];

const fileUploadQuestionTypes = [
  QuestionTypeEnum.FileUploadVideo.toString(),
  QuestionTypeEnum.FileUploadImage.toString(),
  QuestionTypeEnum.FileUploadDocument.toString(),
];
export const isFileUploadQuestionType = (type: string) =>
  fileUploadQuestionTypes.includes(type);

export const isMultipleChoiceOrAnswersQuestionType = (type: string) =>
  multipleChoiceOrAnswersQuestionTypes.includes(type);

export function canHaveAnswers(type: QuestionType | undefined) {
  if (!type?.value) {
    return false;
  }

  return (
    isMultipleChoiceOrAnswersQuestionType(type.value) ||
    (type?.gradingType === QuestionGradingType.Manual &&
      !isFileUploadQuestionType(type.value))
  );
}

export function canHaveConfidenceLevels(type: QuestionType | undefined) {
  return type?.value !== QuestionTypeEnum.CategoryHeader;
}

export function canHaveFeedback(type: QuestionType | undefined) {
  return type?.value && !isFileUploadQuestionType(type.value);
}
